module.exports = __webpack_public_path__ + "img/people_also_ask.731fc7d3.svg";